export default "__VITE_ASSET__Dr4R3MhK__"